/**
 * @file launchMessageProvider.js
 * @author Fernando Ruano
 * @description launch message hook
 */

// Dependencies
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { message as msg } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

// Redux Actions
import * as actions from '@nephro/redux/stores/app/actions';

/**
 * Map state to props
 * @returns { object }
 */
export const mapStateToProps = (state) => ({
  response: state.getIn(['AppState', 'response']).toJS()
});

/**
 * Map dispatch to props
 * @param dispatch - Run the  process to execute in the action
 * @returns { object }
 */
export const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch)
});

/**
 * launchMessageProvider React hoc
 */
function LaunchMessageProvider({ children, response }) {
  const { t: translate } = useTranslation();
  const { type, message } = response;

  React.useEffect(() => {
    if (message) msg[type](translate(message));
  }, [response]);
  return React.Children.only(children);
}

// Proptypes allowed
LaunchMessageProvider.propTypes = {
  children: PropTypes.element.isRequired,
  response: PropTypes.object.isRequired
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LaunchMessageProvider);
